export default __webpack_public_path__ + "static/features-screenshot-c0a021c70cf65301c4e4ea3239d3288a.jpg";